/* eslint-disable no-console */

import { Bugfender, LogLevel } from '@bugfender/sdk';
import { ENVIRONMENTS } from './consts';

export const TAG_XMPP_SEND = 'XMPP Send';
export const TAG_XMPP_RECV = 'XMPP Recv';
export const TAG_XMPP_CLIENT = 'XMPP Client';
export const TAG_SIGNALING = 'Signaling';
export const TAG_CHAT = 'Chat';
export const TAG_WEBRTC = 'WebRTC';
export const TAG_API = 'API';
export const TAG_PRESENCE = 'Presence';
export const TAG_BRANCH_IO = 'Branch.io';
export const TAG_UI = 'UserInterface';

export const log = (...params) => {
  try {
    if (process.env.PREACT_APP_ENV === ENVIRONMENTS.DEVELOPMENT) {
      console.log(...params);
    }
    Bugfender.log(...params);
  } catch (err) {
    console.error(err);
  }
};

export const info = (...params) => {
  try {
    if (process.env.PREACT_APP_ENV === ENVIRONMENTS.DEVELOPMENT) {
      console.info(...params);
    }
    Bugfender.info(...params);
  } catch (err) {
    console.error(err);
  }
};

export const error = (...params) => {
  try {
    if (process.env.PREACT_APP_ENV === ENVIRONMENTS.DEVELOPMENT) {
      console.error(...params);
    }
    Bugfender.error(...params);
  } catch (err) {
    console.error(err);
  }
};

export const warn = (...params) => {
  try {
    if (process.env.PREACT_APP_ENV === ENVIRONMENTS.DEVELOPMENT) {
      console.warn(...params);
    }
    Bugfender.warn(...params);
  } catch (err) {
    console.error(err);
  }
};

export const reportCrash = (title, message) => {
  Bugfender.sendCrash(title, message);
};

const logToConsoleBasedOnLogLevel = (logLevel, ...params) => {
  if (process.env.PREACT_APP_ENV === ENVIRONMENTS.DEVELOPMENT) {
    switch (logLevel) {
      case LogLevel.Error:
        console.error(...params);
        break;
      case LogLevel.Warning:
        console.warn(...params);
        break;
      case LogLevel.Fatal:
        console.error(...params);
        break;
      case LogLevel.Info:
        console.log(...params);
        break;
      default:
        console.log(...params);
        break;
    }
  }
};

const stringifyExtraInfo = (extraInfo) => {
  if (extraInfo) {
    if (typeof extraInfo === 'object') {
      return JSON.stringify(extraInfo, null, 2);
    }
    return `${extraInfo}`;
  }
  return '';
};

export const logWithTag = (file, method, tag, text, level = LogLevel.Info, extraInfo, localOnly = false) => {
  try {
    const logMessage = extraInfo ? `${text}: ${stringifyExtraInfo(extraInfo)}` : text;
    if (!localOnly) {
      Bugfender.sendLog({
        file,
        level,
        method,
        tag,
        text: logMessage,
      });
    }

    if (extraInfo) {
      logToConsoleBasedOnLogLevel(level, `${tag} | ${method} | ${text}`, extraInfo);
    } else {
      logToConsoleBasedOnLogLevel(level, `${tag} | ${method} | ${text}`);
    }
  } catch (err) {
    console.error(err);
  }
};

export const logXMPPSend = (file, method, text, level = LogLevel.Info, extraInfo) => {
  logWithTag(file, method, TAG_XMPP_SEND, text, level, extraInfo);
};

export const logXMPPReceive = (file, method, text, level = LogLevel.Info, extraInfo) => {
  logWithTag(file, method, TAG_XMPP_RECV, text, level, extraInfo);
};

export const logXMPPClient = (file, method, text, level = LogLevel.Info, extraInfo) => {
  logWithTag(file, method, TAG_XMPP_CLIENT, text, level, extraInfo);
};

export const logSignaling = (file, method, text, level = LogLevel.Info, extraInfo) => {
  logWithTag(file, method, TAG_SIGNALING, text, level, extraInfo);
};

export const logChat = (file, method, text, level = LogLevel.Info, extraInfo) => {
  logWithTag(file, method, TAG_CHAT, text, level, extraInfo);
};

export const logWebRTC = (file, method, text, level = LogLevel.Info, extraInfo) => {
  logWithTag(file, method, TAG_WEBRTC, text, level, extraInfo);
};

export default {
  log,
  info,
  error,
  warn,
  reportCrash,
  logXMPPSend,
  logXMPPReceive,
  logXMPPClient,
  logSignaling,
  logWebRTC,
  logChat,
  logWithTag,
  TAG_SIGNALING,
  TAG_WEBRTC,
  TAG_CHAT,
  TAG_XMPP_CLIENT,
  TAG_XMPP_RECV,
  TAG_XMPP_SEND,
};



// WEBPACK FOOTER //
// ./utils/logger.js